<template>
  <section>
    <div>
      <p><b>Atenção:</b> Pode levar entre 10~20 Minutos para puxar os dados inicias de marketing.</p>
    </div>
    <div class="box margin-top-l">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
            <h3>Perfil(s) Google Ads</h3>
            <div class="margin-top-s">
              Status:
              <span v-if="hasOneIntegrationActive">
                <b style="color: green;">ATIVA</b>
              </span>
              <span v-else>
                <b style="color: red;">DESATIVADA</b>
                <p>
                  <small>Entre com sua conta do google ads para ativar.</small>
                </p>
              </span>
            </div>
          </div>
        <div class="flex-1 flex end">
          <div>
              <div>
                <div class="google-btn"  @click="showModal = true">
                  <div class="google-icon-wrapper">
                    <img class="google-icon" src="@/assets/img/google-icon.png"/>
                  </div>
                  <p class="btn-text"><b>Entrar com o Google</b></p>
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
      <div class="box-content">
        <div class="list-account">
          <p>
            <b>Atenção:</b> Nossa integração do Google Ads está passando por Homologação. Você pode útilizar sem problemas mas um aviso de seguraça vai ser exibido na hora de liberar acesso.
          </p>
          <!-- list accounts -->
          <p class="margin-top-l">
            Lista dos perfils que você liberou acesso:
          </p>
          <ul class="margin-top-l">
            <li v-for="(pro, index) in profiles" :key="index">
              <div class="flex middle">
                <div class="flex-3">
                  {{ pro.name }} - {{ pro.email }}
                </div>
                <div class="flex-1">
                  <div class="flex end">
                    <div v-if="pro.status === 'ACTIVE'" class="button secondary" @click="deleteIntegration(pro)">Remover Perfil</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loadingProfiles">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
    </div>
    <!-- accounts -->
    <div  class="box margin-top-l" style="margin-left: 0px;">
      <div class="box-title">
        <div class="flex middle">
          <div class="flex-1">
            <h3>Contas de anúncio: {{ countActiveAccounts }}/{{ accountsLimit }}</h3>
            <p>Precisa de mais conta de anúncio ativas? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></p>
          </div>
        </div>
      </div>
      <div
          v-if="checkResource('config-accounts-gads')"
          class="box-content"
        >
        <div class="list-account">
          <!-- list accounts -->
          <p>
            Lista de contas de anúncio com acesso. Ative a conta que deseja ter
            os dados de custo no painel:
          </p>
          <ul class="margin-top-l">
            <li v-for="(acc, index) in accounts" :key="index">
              <div class="flex">
                <div class="flex-3">{{ acc.name }}</div>
                <div class="flex-1">
                  <div class="flex end">
                    <m-switch
                      v-if="(acc.is_active && !hasSlotToAccout) || (hasSlotToAccout)"
                      v-model="acc.is_active"
                      @change="saveChanges(acc)"
                    ></m-switch>
                    <div v-else class="flex center end" >* Faça upgrade para tivar mais contas</div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
      <div v-else class="box-content">
        <p> Seu plano não tem a funcionalidade de GOOGLE ADS. <router-link :to="{ name: 'SubscriptionRedirect' }"><b>Faça o UPGRADE para poder utilizar esse recurso</b></router-link></p>
      </div>
    </div>

      <modal
        title="Conectar Google Ads"
        :show="showModal"
        @close="showModal = false"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100 center">
            <div class="flex flex-1 w100 center">
              <p>Escolha como você quer conectar sua conta da Google Ads</p>
            </div>
            <div class="flex-1 column middle flex w100 center margin-top-l">
              <div class="button primary"  @click="createLoginGoogleOauth2()">Continuar neste Navegador</div>
              <small class="margin-top-s">Conecte sua conta Google Ads diretamente neste navegador.</small>
            </div>
            <div class="flex-1 flex column middle w100 center w100 margin-top-l">
              <div class="button secondary" @click="createLoginGoogleOauth2(true)">Copiar link para navegador multilogin</div>
              <small class="margin-top-s">Gere um link para conectar em outro navegador ou compartilhar com colaboradores.</small>
            </div>
            <div v-if="false" class="flex w100 center margin-top-l">
              <div class="button secondary" @click="showModal = false">Fechar</div>
            </div>
          </div>
        </div>
      </modal>

  </section>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";

import {
  getIntegrations,
  initGoogleOauth2,
  saveIntegration,
  getAccountsGoogleAds,
  deleteIntegration,
} from "@/services/integration";

import MSwitch from "@/components/MSwitch.vue";

export default {
  components: { 
    MSwitch,
    Modal
  },
  name: "google-ads",
  data() {
    return {
      showModal: false,
      accounts: [],
      profiles: [],
      accountsIntegration: [],
      newAccountFacebookAds: "",
      detectTokenDataOauth: null,
      showModalDelete: false,
      showModalDeleteIntegration: false,
      modalNewAccount: false,
      loading: false,
      loadingProfiles: false,
      timerToRequest: 3000,
    };
  },
  computed: {
    ...mapState({ account: (state) => state.account }),
    hasIntegration() {
      return this.profiles && this.profiles.length > 0;
    },
    hasOneIntegrationActive() {
      let status = false

      this.profiles.forEach(p => {
        status = p.status == 'ACTIVE'
        if (status) return
      })

      return status
    },
    accountsLimit() {
      if (!this.account) {
        return
      }

      return this.account.plan_limits.limit_accounts_gads
    },
    countActiveAccounts() {
      if (!this.accounts) {
        return true
      }

      let count = 0
      this.accounts.forEach(a => {
        if (a.is_active) {
          count += 1
        }
      })

      return count
    },
    hasSlotToAccout() {
      if (this.account.plan_limits.limit_accounts_gads === 0) {
        return true
      }

      return this.countActiveAccounts < this.account.plan_limits.limit_accounts_gads
    }
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.detectTokenDataOauth);
  },
  methods: {
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    deleteIntegration(integration) {
      deleteIntegration(integration.id)
        .then(() => {
          this.accounts = this.accounts.filter((acc) => { return acc.integration_id != integration.id });
          this.profiles = this.profiles.filter((pro) => { return pro.id != integration.id })

          this.$toast.success({
            title: "Sucesso",
            message: "Integração removida com sucesso",
          });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar deletar integração",
          });
        });
    },
    selectModalDelete(accountId) {
      this.showModalDelete = true;
      this.selectedAccount = accountId;
    },
    saveChanges(acc) {
      let params = {
        google: {
          integration_id: acc.integration_id,
          accounts: this.accounts.filter((a) =>  {
            return a.is_active && a.integration_id === acc.integration_id
          }),
        },
      };
      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: `Integração com Google salva com sucesso.`,
          });
          //this.getData();
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar salvar integração",
          });
        });
    },
    getData(notLoading) {
      if (!notLoading) {
        this.loadingProfiles = true;
      }

      getIntegrations()
        .then((result) => {
          this.accountsIntegration = [];
          result.googleads.forEach((element) => {
            element.accounts.forEach((acc) => {
              acc.is_active = true;
              acc.integration_id = element.id;

              this.accountsIntegration.push(acc)
            })
          });

          // detect change profile list
          if (this.profiles.length !== result.googleads.length) {
            clearInterval(this.detectTokenDataOauth);
            
            if (this.checkResource('config-accounts-gads')) {
              this.getAccountsGoogleAds();
            }
          }

          this.profiles = result.googleads
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          console.log('error', error)
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar buscar integrações",
          });
        })
        .finally(() => {
          this.loadingProfiles = false;
        });
    },
    getAccountsGoogleAds() {
      this.loading = true;
      this.accounts = []

      getAccountsGoogleAds()
        .then((responseGADS) => {
          let accountsIds = this.accountsIntegration.map((acc) => acc.id);

          responseGADS.accounts.forEach((element) => {
            let is_active = false;
            if (accountsIds.includes(element.id)) {
              is_active = true;
            }
            this.accounts.push(
              Object.assign(element, { is_active: is_active })
            );
          });

          this.accounts = this.accounts.sort(function(a, b) {
            return !a.is_active && b.is_active;
          });

          this.accounts = this.$ObjectCopy(this.accounts);
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createLoginGoogleOauth2(link) {

      this.detectTokenDataOauth = setInterval(() => {
        this.getData(true);
      }, this.timerToRequest);

      initGoogleOauth2()
        .then((result) => {
          // set interval to refresh screen to get data

          if (!link) {
            this.win = window.open(
              result.url,
              "Oauth2",
              "resizable,height=800,width=600"
            );
          } else {
            navigator.clipboard.writeText(result.url);
            this.$toast.success({
              title: "Sucesso",
              message: "Link de liberação copiado!",
            });
          }
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-account {
  ul {
    list-style-type: none;
    li {
      margin-bottom: 8px;
      padding: 16px;
      border-radius: 5px;
      border: 1px solid var(--border);
    }
  }
}

$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn {
  width: 200px;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  cursor: pointer;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);

  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $white;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    float: right;
    margin: 11px 11px 0 0;
    color: $white;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
  }
  &:active {
    background: $button-active-blue;
  }
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);

</style>
